

// window.lazySizesConfig = window.lazySizesConfig || {};
// window.lazySizesConfig.lazyClass = 'byzoom-lazy';
// lazySizesConfig.srcAttr = 'data-original';

document.addEventListener('DOMContentLoaded', function() {
  var unsubscribeLink = document.getElementById('unsubscribe_link');

  if (unsubscribeLink) {
    unsubscribeLink.addEventListener('click', function(event) {
      event.preventDefault();
      var dataId = unsubscribeLink.getAttribute('data-id');
      updateCustomerAcceptsMarketing(dataId, false).then(r => {});
      unsubscribeLink.style.display = 'none';
    });
  }
});

async function updateCustomerAcceptsMarketing(customerId, acceptsMarketing) {
  const response = await fetch(`https://byzoomeu.wowio.co/api/customer-marketing`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({customer_id: customerId, accepts_marketing: acceptsMarketing})
  });

  const responseData = await response.json();

  return responseData;
}
